<template>
  <div class="ball-clip-rotate">
    <div></div>
  </div>
</template>

<script>
export default {
  name: 'modalLoadingBallClipRotate',
};
</script>
